import React from 'react';
import {EgovError} from "../../../components";

const Error = () => {
    return <EgovError/>
};

export default Error;
